var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-chip',{attrs:{"color":_vm.statusColor[_vm.data]}},[_vm._v("\n  "+_vm._s(_vm.data)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }